import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
var emptyStateStyles = xcss({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 'space.100',
  height: '100%',
  justifyContent: 'center',
  marginLeft: 'space.300',
  marginRight: 'space.300',
  textAlign: 'center'
});
var descriptionStyles = xcss({
  marginTop: 'space.0',
  marginBottom: 'space.300',
  color: 'color.text'
});
export var EmptyStateOld = function EmptyStateOld(_ref) {
  var testId = _ref.testId,
    header = _ref.header,
    description = _ref.description,
    renderImage = _ref.renderImage;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: emptyStateStyles,
    testId: testId
  }, renderImage === null || renderImage === void 0 ? void 0 : renderImage(), /*#__PURE__*/React.createElement(Heading, {
    size: "small"
  }, header), description && /*#__PURE__*/React.createElement(Box, {
    as: "p",
    xcss: descriptionStyles
  }, description));
};